var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isSitecoreExperienceEditorOn)?_c('p',{class:this.className,domProps:{"innerHTML":_vm._s(_vm.multiLineContent)}}):_c('sc-text',{class:this.className,attrs:{"field":_vm.multilineField,"tag":"p"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }